<header>
  <app-nav-menu></app-nav-menu>
  <shared-toasts></shared-toasts>
</header>
<main class="container mb-5">
  <router-outlet></router-outlet>
</main>
<footer class="d-print-none">
  <app-footer></app-footer>
</footer>
